import { getIdentityUrl, getWACUrl } from '@css-xp/ppc-utils';

export const getProvisioningUrl = (newSiteOrderId: string, transactionAccountId: string, email: string): string => {
  const queryParams = [
    `login_hint=${encodeURIComponent(email)}`,
    `prompt=none`,
    `continue=${encodeURIComponent(
      `${getWACUrl()}/buy/cloud/site-setup?orderId=${newSiteOrderId}&transactionAccount=${transactionAccountId}`
    )}`,
  ];
  return `${getIdentityUrl()}/login?${queryParams.join('&')}`;
};

export const ADMIN_PERMISSION_URL = 'https://support.atlassian.com/user-management/docs/give-users-admin-permissions/';
